module.exports = __webpack_public_path__ + "img/yellow_unlock.ed93c643.png";